import styled from "@emotion/styled";
import React from "react";
import { CustomThemeType } from "../context/Providers";

const InputWrapper = styled.input<{ theme?: CustomThemeType }>`
  color: ${(p) => p.theme.foreground};
  padding: 0.5rem;
  background-color: ${(p) =>
    `color-mix(in hsl, ${p.theme.background}, ${p.theme.foreground} 10%)`};
  border: none;
  border-radius: 0.25rem;
  outline: none;
`;

const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (
  props
) => {
  return <InputWrapper {...props} />;
};

export default Input;
